import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { createFormikValidate } from '../../../utils/yupValidation';
import { resetPassword, forgotpassword } from '../../../services/AuthService';
import { legacy_connect as connect } from 'react-redux';
import { preventEnterSubmit } from '../../../utils/Constant';
import { setIsLogin } from '../../../redux/loginSlice';
import { toasterAlert } from '../../../redux/toasterSlice';
import SimpleInput from '../../../components/SimpleInput';
import InputBtn from '../../../components/InputBtn';
import { withRouter } from '../../../utils/withRouter';
import { BsArrowLeft, BsArrowRepeat, BsHourglassSplit, BsImage, BsLock, BsPerson, BsSend } from 'react-icons/bs';

const validationSchema = function (values: any) {
  return Yup.object().shape({
      username: Yup.string().email('Must be a valid email').required('User name is required')
  });
};
const validationSchemaResetPassword = function (values: any) {
  return Yup.object().shape({
    password: Yup.string()
      .min(8, `Password has to be at least ${8} characters!`)
      .matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/, 'Password must contain: numbers, uppercase and lowercase letters\n')
      .required('New password is require'),
    confirmationCode: Yup.string().required('Confirmation code is required'),
    username: Yup.string().email('Must be a valid email').required('User name is required')
  });
};

const validate = createFormikValidate;

interface InputProps {
  toasterAlert: (data: any) => void;
  isLogin?: boolean;
  history: any;
  isMobile: boolean;
  location: any;
}
class Forgotpassword extends React.Component<InputProps, any> {
  constructor (props: InputProps) {
    super(props);
    this.state = {
      showResetPassword: false,
      isImageLoaded: false,
      isImageError: false
    };
  }

  componentDidMount () {
    if (this.props?.location?.pathname === '/resetpassword') {
      this.setState({
        showResetPassword: true
      })
    }
  }

  redirectToLogin = () => {
    this.props.history.push('/login');
  }

  forgotPasswordCall = (values: any, actions: any) => {
    const username = values.username;
    forgotpassword(username).then(async (data: any) => {
        if (data.CodeDeliveryDetails !== undefined && data.CodeDeliveryDetails !== '') {
          actions.setSubmitting(false);
          actions.resetForm();
          this.setState({
            showResetPassword: true
          })
          this.props.toasterAlert({
            type: 'success',
            title: 'Success',
            message: 'You have got confirmation code in email.'
          });
        } else {
          actions.setSubmitting(false);
          this.props.toasterAlert({
            type: 'error',
            title: 'Something went wrong!',
            message: 'There is some issue, please try after sometime.'
          });
        }
      })
      .catch((e) => {
        actions.setSubmitting(false);
        this.props.toasterAlert({
          type: 'error',
          title: 'Something went wrong!',
          message: e?.response?.data?.hint ?? 'There is some issue, please try after sometime.'
        });
      });
  };

  onSubmitChangePassword = (values: any, actions: any) => {
    const dataObj: any = {
      confirmationCode: values.confirmationCode,
      username: values.username,
      password: values.password
    };
    const authData = JSON.stringify(dataObj);

    resetPassword(authData).then((data: any) => {
      this.props.toasterAlert({
        title: 'Reset Success!',
        message: 'Your password reset successfully!!'
      });
      setTimeout(() => {
        this.props.history.push('/login');
      }, 2500)
    })
    .catch((e) => {
      actions.setSubmitting(false);
      this.props.toasterAlert({
        type: 'error',
        title: 'Something went wrong!',
        message: e?.response?.data?.hint ?? 'There is some issue, please try after sometime.'
      });
    });
  };

  render () {
    return (
      <div className="c-app flex justify-center items-center w-full h-full xl:w-1/2 mx-auto">
          <div className="irpm__row flex-col">
            <div className="login-logo-container">
              <img className="login-logo-image" src="images/InsightLogin.png" alt="" />
            </div>
            <div className="login-box">
              <div className="irpm__card flex p-0">
                <div className="irpm__card-body p-4 flex-1">
                    {
                      this.state.showResetPassword
                        ? <Formik
                            initialValues={{ username: '', confirmationCode: '', password: '' }}
                            validate={validate(validationSchemaResetPassword)}
                            onSubmit={this.onSubmitChangePassword}
                          >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            isValid,
                            handleReset
                          }) => (
                            <form onKeyDown={preventEnterSubmit} onSubmit={handleSubmit} noValidate name="changePasswordForm">
                              <h1 className="text-4xl font-semibold mb-2">Reset Password</h1>
                              <p className="text-muted mb-3">Reset your password</p>
                              <div className="flex mb-4">
                                <span className="inline-flex items-center px-3 py-2 text-sm text-gray-900 bg-blue-100 rounded-l-md border border-r-0 border-gray-300">
                                  <BsPerson style={{ fontSize: '1.1rem' }}/>
                                </span>
                                <SimpleInput
                                  type="text"
                                  name="username"
                                  id="username"
                                  placeholder="User Name"
                                  autoComplete="username"
                                  valid={!errors.username}
                                  invalid={touched.username && !!errors.username}
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.username}
                                />
                              </div>
                              <div className="flex mb-4">
                                <span className="inline-flex items-center px-3 py-2 text-sm text-gray-900 bg-blue-100 rounded-l-md border border-r-0 border-gray-300">
                                  <BsLock style={{ fontSize: '1.1rem' }}/>
                                </span>
                                <SimpleInput
                                  type="text"
                                  placeholder="Confirm Code"
                                  autoComplete="new-password"
                                  name="confirmationCode"
                                  id="confirmationCode"
                                  valid={!errors.confirmationCode}
                                  invalid={touched.confirmationCode && !!errors.confirmationCode}
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.confirmationCode}
                                />
                              </div>
                              <div className="flex mb-4">
                                <span className="inline-flex items-center px-3 py-2 text-sm text-gray-900 bg-blue-100 rounded-l-md border border-r-0 border-gray-300">
                                  <BsLock style={{ fontSize: '1.1rem' }}/>
                                </span>
                                <SimpleInput
                                  type="password"
                                  placeholder="New Password"
                                  autoComplete="new-password"
                                  name="password"
                                  id="password"
                                  valid={!errors.password}
                                  invalid={touched.password && !!errors.password}
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.password}
                                />
                              </div>
                              <div className="login-form-actions">
                                <InputBtn
                                  type="submit"
                                  className="button button-primary login-submit-btn"
                                  disabled={isSubmitting || !isValid}
                                >
                                  {isSubmitting
                                    ? <><BsHourglassSplit size={18} aria-hidden="true" /> Wait...</>
                                    : <><BsArrowRepeat size={18} aria-hidden="true" /> Reset Password</>}
                                </InputBtn>
                                <button
                                  type="button"
                                  className="login-forgot-link"
                                  onClick={this.redirectToLogin}
                                >
                                  <BsArrowLeft size={16} aria-hidden="true" />
                                  Back to Login
                                </button>
                              </div>
                            </form>
                          )}
                          </Formik>

                        : <Formik
                            initialValues={{ username: '' }}
                            validate={validate(validationSchema)}
                            onSubmit={this.forgotPasswordCall}
                          >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            isValid,
                            handleReset
                          }) => (
                            <form onSubmit={handleSubmit} noValidate name="forgotForm">
                              <h1 className="text-2xl font-semibold mb-2">Forgot Password</h1>
                              <div className="flex mb-4">
                                <span className="inline-flex items-center px-3 py-2 text-sm text-gray-900 bg-blue-100 rounded-l-md border border-r-0 border-gray-300">
                                  <BsPerson style={{ fontSize: '1.1rem' }}/>
                                </span>
                                <SimpleInput
                                  type="text"
                                  name="username"
                                  id="username"
                                  placeholder="Username"
                                  autoComplete="username"
                                  valid={!errors.username}
                                  invalid={touched.username && !!errors.username}
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.username}
                                />
                              </div>

                              <div className="login-form-actions">
                                <InputBtn
                                  type="submit"
                                  className="button button-primary login-submit-btn"
                                  disabled={isSubmitting || !isValid}
                                >
                                  {isSubmitting
                                    ? <><BsHourglassSplit size={16} aria-hidden="true" /> Wait...</>
                                    : <><BsSend size={16} aria-hidden="true" /> Submit</>}
                                </InputBtn>
                                <button
                                  type="button"
                                  className="login-forgot-link"
                                  onClick={this.redirectToLogin}
                                >
                                  <BsArrowLeft size={14} aria-hidden="true" />
                                  Back to Login
                                </button>
                              </div>
                            </form>
                          )}
                      </Formik>
                    }
                </div>
                <div className="login-fold flex-1">
                  <div className="login-image relative w-full h-full bg-slate-100 flex items-center justify-center overflow-hidden">
                    {!this.state.isImageLoaded && !this.state.isImageError && (
                      <div className="absolute inset-0 flex flex-col items-center justify-center bg-slate-100 text-slate-400 animate-pulse z-10">
                        <BsHourglassSplit className="animate-spin text-2xl mb-2 text-blue-600" />
                        <span className="text-xs font-medium text-slate-500">Loading image...</span>
                      </div>
                    )}
                    {this.state.isImageError ? (
                      <div className="flex flex-col items-center justify-center p-6 text-slate-400 bg-slate-100 w-full h-full">
                        <BsImage className="text-4xl mb-2 text-slate-400" />
                        <span className="text-sm font-medium text-slate-500">Care Management</span>
                      </div>
                    ) : (
                      <img
                        src="images/loginBanner.jpg"
                        alt="Login Banner"
                        width="500"
                        height="340"
                        onLoad={() => this.setState({ isImageLoaded: true })}
                        onError={() => this.setState({ isImageError: true })}
                        className={`w-full h-full object-cover transition-opacity duration-300 ${
                          this.state.isImageLoaded ? 'opacity-100' : 'opacity-0'
                        }`}
                      />
                    )}
                  </div>
                  <h4>
                    Reducing hospitalizations through preventative care.
                  </h4>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}
function mapStateToProps (state: any) {
  return {
    isLogin: state.user_loggedin.isLogin,
    isMobile: state.global.isMobile
  };
}

const mapDispatchToProps = {
  toasterAlert,
  setIsLogin
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Forgotpassword));
